import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router";
import ErrorBoundary from "../components/common/ErrorBoundary";
import PageLoader from "../components/common/PageLoader";
import LandingPage from "../pages/Landing/LandingPage";

function LandingRoutes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default LandingRoutes;
